<template>
    <div class="pt-8">
        <FilterForm 
            :filter="filter" 
            @get-invitations-list="getInvitationsList()" 
            @clear-filter-form="clearFilterForm()" 
        />
        <InvitationsTable 
            :invitations="invitations" 
            :paginator="paginator" 
            :pageSize="pageSize" 
            @open-lookup-modal="openModalLookup = true"
            @open-massive-upload-modal="openModalMassiveUpload = true"
            @get-invitations-list="getInvitationsList()"
            @go-to-update="goToUpdate($event)"
            @resend-invitation="handleResend($event)"
            @cancel-invitation="handleCancel($event)"
            @change-page="changePage($event)" 
            
        />

        <ModalLookupInvitation
            :openLookupModal="openModalLookup"
            :lookupData="lookupData"
            @confirm-lookup="handleLookup"
            @close-modal="closeModalLookup"
        />

        <ModalMassiveUpload
            :modalVisible="openModalMassiveUpload"
            :isLoading="isLoading"
            @close-modal="openModalMassiveUpload = false"
            @update:isLoading="isLoading = $event"
            @get-invitations-list="getInvitationsList()"
        />
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import FilterForm from '../components/FilterForm.vue'
import InvitationsTable from '../components/InvitationsTable.vue'
import ModalLookupInvitation from '../components/HandleLookupModal.vue';
import ModalMassiveUpload from '../components/InvitationsModal.vue';

export default {
    computed: {
        ...mapState('auth', ['user'])
    },
    data(){
        return{
            invitations: [],
            filter: {
                nit: "",
                name: "",
                email: "",
                status:   null,
                dateFrom: "",
                dateTo:   "",
            },
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            openModalLookup: false,
            openModalMassiveUpload: false,
            isLoading: false,
            lookupData: {
                nit:     '',
                loading: false,
                error:   null,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
        }
    },
    components: {
        FilterForm,
        InvitationsTable,
        ModalLookupInvitation,
        ModalMassiveUpload
    },
    created(){
        this.getInvitationsList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getInvitationsList(){
            this.pageOptions = {
                pageNumber: this.paginator.page, 
                pageSize:   this.paginator.pageSize,
                nit:     this.filter.nit,
                name:      this.filter.name,
                email:      this.filter.email,
                status:     this.filter.status,
                dateFrom:   this.filter.dateFrom,
                dateTo:     this.filter.dateTo,
            }
            this.setLoading(true)
            await this.$conectar.post('/admin/chatbot-invitations/list', this.pageOptions)
            .then(response =>{
                this.invitations = response.data.invitationList;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getInvitationsList();
        },
        clearFilterForm(){
            this.filter.nit = "";
            this.filter.name = "";
            this.filter.email = "";
            this.filter.status = null;
            this.filter.dateFrom = "";
            this.filter.dateTo = "";
            this.paginator.pageSize = 10;
        },
        closeModalLookup() {
            this.openModalLookup  = false;
            this.lookupData.nit   = '';
            this.lookupData.error = null;
        },

        async handleLookup() {
            this.lookupData.loading = true;
            this.lookupData.error   = null;

            try {
                const { data } = await this.$conectar.post('/admin/chatbot-invitations/lookup', {
                    nit: this.lookupData.nit
                });

                this.closeModalLookup();

                this.$router.push({
                    name: 'chatbot-invitations.register',
                    params: {
                        company:     data.company,
                        lookupToken: data.lookup_token
                    }
                });

            } catch (error) {
                this.lookupData.error = error.response?.data?.message || 'Error al buscar el NIT';
            } finally {
                this.lookupData.loading = false;
            }
        },

        goToUpdate(invitation) {
            this.$router.push({
                name: 'chatbot-invitations.update',
                params: { invitation }
            });
        },

        async handleResend(id) {
            this.setLoading(true);

            await this.$conectar.post(`/admin/chatbot-invitations/${id}/resend`)
            .then(response => {
                if (response.data.error == true) {
                    this.$root.$bvToast.toast(response.data.message, {
                        title:   'Respuesta del servidor',
                        variant: 'danger',
                        solid:   true
                    });
                } else {
                    this.$root.$bvToast.toast(response.data.message, {
                        title:   'Respuesta del servidor',
                        variant: 'success',
                        solid:   true
                    });
                    this.getInvitationsList();
                }
            })
            .catch(() => {
                this.$root.$bvToast.toast('Error en el servidor, favor intente nuevamente más tarde', {
                    title:   'Respuesta del servidor',
                    variant: 'danger',
                    solid:   true
                });
            });

            this.setLoading(false);
        },

        async handleCancel(id) {
            const confirmed = await this.$bvModal.msgBoxConfirm(
                '¿Está seguro que desea cancelar esta invitación?', {
                    title:           'Confirmar cancelación',
                    okVariant:       'danger',
                    okTitle:         'Sí, cancelar',
                    cancelTitle:     'No',
                    centered:        true,
                }
            );

            if (!confirmed) return;

            this.setLoading(true);

            await this.$conectar.post(`/admin/chatbot-invitations/${id}/cancel`)
            .then(response => {
                if (response.data.error == true) {
                    this.$root.$bvToast.toast(response.data.message, {
                        title:   'Respuesta del servidor',
                        variant: 'danger',
                        solid:   true
                    });
                } else {
                    this.$root.$bvToast.toast(response.data.message, {
                        title:   'Respuesta del servidor',
                        variant: 'success',
                        solid:   true
                    });
                    this.getInvitationsList();
                }
            })
            .catch(() => {
                this.$root.$bvToast.toast('Error en el servidor, favor intente nuevamente más tarde', {
                    title:   'Respuesta del servidor',
                    variant: 'danger',
                    solid:   true
                });
            });

            this.setLoading(false);
        }

    }
}
</script>